import DetailConvertItem from "./DetailConvertItem";

export default DetailConvertItem;
